import { Projectile } from "../entities/Projectile.js";
import { spawnDamageNumber, spawnProjectileImpactEffect } from "../scenes/features/combat/visuals.js";

export function handleNetworkProjectileSpawn(scene, msg) {
  if (!msg || !msg.projectile) return;
  if (!scene.netClient || scene.netStatus !== "connected") return;
  const ownerId = typeof msg.ownerId === "string" ? msg.ownerId : null;
  const packet = msg.projectile;
  const projectileId = packet.id != null ? String(packet.id) : null;
  const spawnToken = typeof packet.spawnToken === "string" ? packet.spawnToken : null;

  if (ownerId && ownerId === scene.netPlayerId) {
    if (!projectileId) return;
    let candidate = spawnToken ? scene.netPendingProjectilesByToken.get(spawnToken) : null;
    if (!candidate) {
      let earliest = Infinity;
      for (const entity of scene.entities) {
        if (!(entity instanceof Projectile)) continue;
        if (entity.markedForRemoval || entity.isNetworkVisual) continue;
        if (!entity.pendingNetworkOwnership) continue;
        const at = Number(entity.networkSpawnedAt) || 0;
        if (at < earliest) {
          earliest = at;
          candidate = entity;
        }
      }
    }
    if (!candidate) return;
    candidate.pendingNetworkOwnership = false;
    candidate.networkProjectileId = projectileId;
    if (spawnToken) scene.netPendingProjectilesByToken.delete(spawnToken);
    scene.netProjectilesById.set(projectileId, candidate);
    return;
  }

  const x = Number(packet.x);
  const y = Number(packet.y);
  const facing = Number(packet.facing);
  const damage = Number(packet.damage);
  if (!Number.isFinite(x) || !Number.isFinite(y) || !Number.isFinite(facing) || !Number.isFinite(damage)) return;

  const proj = new Projectile(
    scene,
    x,
    y,
    facing >= 0 ? 1 : -1,
    damage,
    packet.spriteConfig || null,
    null
  );
  proj.isNetworkVisual = true;
  proj.networkProjectileId = projectileId;
  proj.create();
  scene.entities.push(proj);
  if (projectileId) {
    scene.netProjectilesById.set(projectileId, proj);
  }
}

export function handleNetworkProjectileHit(scene, msg) {
  if (!msg) return;
  const hitX = Number(msg.hitX);
  const hitY = Number(msg.hitY);
  const damage = Number(msg.damage);
  const projectileId = msg.projectileId != null ? String(msg.projectileId) : null;
  let impactSpriteConfig = null;

  if (projectileId) {
    const proj = scene.netProjectilesById.get(projectileId);
    if (proj) {
      impactSpriteConfig = proj.spriteConfig || null;
      if (Number.isFinite(hitX) && Number.isFinite(hitY)) {
        proj.x = hitX - proj.w / 2;
        proj.y = hitY - proj.h / 2;
        if (proj.sprite) {
          proj.sprite.x = hitX;
          proj.sprite.y = hitY;
        }
      }
      proj.markedForRemoval = true;
      proj.destroy();
    }
    scene.netProjectilesById.delete(projectileId);
  }

  if (Number.isFinite(hitX) && Number.isFinite(hitY)) {
    spawnProjectileImpactEffect(scene, impactSpriteConfig || msg.spriteConfig || null, hitX, hitY);
    if (Number.isFinite(damage) && damage > 0) {
      if (!msg.targetId || msg.targetId !== scene.netPlayerId) {
        spawnDamageNumber(scene, hitX, hitY, Math.round(damage));
      }
    }
  }
}
